// extracted by mini-css-extract-plugin
export default {"wrap":"wrap§ZVwGTwf5WqyRecMkf66A","line":"line§voA4AGiEAaJ502peRRR3"};